exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selection-thumbnails[data-v-28f51378] {\n  margin-left: 8px;\n}\n.selection-thumbnails .avatar[data-v-28f51378] {\n  position: relative;\n  margin-left: -8px;\n}", ""]);

// exports
